import React, { useState, useEffect } from 'react';
import { useTranslations } from '../../localization/useTranslations';

interface InputFieldProps {
  label: string;
  placeholder: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  hasError?: boolean;
  autoFocus?: boolean;
}

const InputField: React.FC<InputFieldProps> = ({
  label,
  placeholder,
  value,
  onChange,
  hasError = false,
  autoFocus = false,
}) => {
  const [focused, setFocused] = useState(false);
  const [error, setError] = useState('');
  const translations = useTranslations();

  // Effect to update error message when hasError changes
  useEffect(() => {
    if (hasError) {
      setError(translations?.myAccountSettings?.valueRequired || 'Value is required');
    } else {
      setError('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasError]);

  const handleFocus = () => {
    setFocused(true);
  };

  const handleBlur = () => {
    setFocused(false);
  };

  return (
    <div className="input-group">
      <label className={`input-label ${focused ? 'focused' : ''}`}>{label}</label>
      <input
        type="text"
        placeholder={placeholder}
        value={value || ''}
        onChange={onChange}
        className={error ? 'input-group__input error' : 'input-group__input'}
        autoFocus={autoFocus}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
      {error && <label className="input-error">{error}</label>}
    </div>
  );
};

export default InputField;
